import { 
    GET_ALL_ACTIVITIES,
    CHANGE_TASK_ACTIVITIES,
    TOGGLE_CHECKED_ALL_ACTIVITIES
}  from "../../core/constants";

//action creator
export function getAllActivities ()
{
    return {
        type: GET_ALL_ACTIVITIES
    }
}

//action creator
export function changeTaskActivities (data)
{
    return {
        type: CHANGE_TASK_ACTIVITIES,
        payload: data,
    }
}

//action creator
export function toggleCheckedAllActivities (status)
{
    return {
        type: TOGGLE_CHECKED_ALL_ACTIVITIES,
        payload: status
    }
}